"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Container = _interopRequireDefault(require("react-bootstrap/Container"));
var _reactBootstrap = require("react-bootstrap");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _indexModule = _interopRequireDefault(require("./index.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const TableWrapper = _styledComponents.default.div`
  .table-bordered thead td,
  .table-bordered thead th {
    min-width: 100px !important;
    vertical-align: top !important;
    text-align: center !important;
  }

  th {
    background: #1e91ce;
    font-size: 15px;
    color: #fff;
    font-weight: 500;
    //    border: 1px solid white;
    border-top: 0px !important;
    padding: 0.6rem;
  }
  td {
    padding: 0.5rem;
    border: 1px solid #efefef;
    font-size: 15px;
    background: white;
    vertical-align: middle;
  }
  .table-responsive > .table-bordered {
    border: 0;
    font-size: 15px;
  }
  .table-responsive {
    overflow-x: none;
  }

  .table {
    width: 98%;
    margin-left: 2px;
  }
  @media (max-width: 768px) {
    .table-bordered thead td,
    .table-bordered thead th {
      min-width: auto !important;
      vertical-align: top !important;
      min-width: 100px !important;
    }
    .table-bordered > thead > tr > th:first-child {
      width: auto !important;
    }
    .table-responsive {
      overflow-x: auto;
    }
  }
`;
const DocsNeeded = _ref => {
  let {
    location
  } = _ref;
  (0, _react.useEffect)(() => {
    window.scrollTo(0, 0);
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: _indexModule.default.hero_image
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h1", null, "Documents Needed"))), /*#__PURE__*/_react.default.createElement(_Container.default, {
    className: _indexModule.default.pageContainer
  }, /*#__PURE__*/_react.default.createElement(_Container.default, {
    fluid: true
  }, /*#__PURE__*/_react.default.createElement(TableWrapper, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Table, {
    responsive: true
  }, /*#__PURE__*/_react.default.createElement("thead", {
    style: {
      backgroundColor: '#78b1e2'
    }
  }, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
    style: {
      textAlign: 'center'
    }
  }, "Documents"), /*#__PURE__*/_react.default.createElement("th", {
    style: {
      borderLeft: '2px solid #fff',
      textAlign: 'center'
    }
  }, "Purchase"), /*#__PURE__*/_react.default.createElement("th", {
    style: {
      borderLeft: '2px solid #fff',
      textAlign: 'center'
    }
  }, "Refinance"))), /*#__PURE__*/_react.default.createElement("tbody", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
    colSpan: "3",
    style: {
      background: '#ececec'
    }
  }, /*#__PURE__*/_react.default.createElement("b", null, "Identification Documents"))), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, "Driver's License"), /*#__PURE__*/_react.default.createElement("td", {
    rowSpan: "2",
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("b", null, "Yes")), /*#__PURE__*/_react.default.createElement("td", {
    rowSpan: "2",
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("b", null, "Yes"))), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, "Social Security Card")), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
    colSpan: "3",
    style: {
      background: '#ececec'
    }
  }, /*#__PURE__*/_react.default.createElement("b", null, "Income Documents"))), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
    colSpan: "3"
  }, /*#__PURE__*/_react.default.createElement("b", null, /*#__PURE__*/_react.default.createElement("em", null, "Salaried")))), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, "Pay Stubs for 2 recent pay periods"), /*#__PURE__*/_react.default.createElement("td", {
    rowSpan: "3",
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("b", null, "Yes")), /*#__PURE__*/_react.default.createElement("td", {
    rowSpan: "3",
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("b", null, "Yes*"))), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, "Last two years - W2 forms, 1099's")), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, "Last two years - 1040 (Personal Federal Tax Returns) with all supporting schedules.")), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
    colSpan: "3"
  }, /*#__PURE__*/_react.default.createElement("b", null, /*#__PURE__*/_react.default.createElement("em", null, "Self Employed")))), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, "Current year's Year to date Profit and Loss Statement to current month"), /*#__PURE__*/_react.default.createElement("td", {
    rowSpan: "3",
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("b", null, "Yes")), /*#__PURE__*/_react.default.createElement("td", {
    rowSpan: "3",
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("b", null, "Yes*"))), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, "Last two years - Form 1120S / Form 1065 / Form 1120 Federal Corporate tax returns only with all supporting schedules")), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, "Last two years \u2013 K-1's with all supporting schedules")), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
    colSpan: "3"
  }, /*#__PURE__*/_react.default.createElement("b", null, /*#__PURE__*/_react.default.createElement("em", null, "Other Income")))), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, "Retirement Benefit Award letters with proof of 3 years continuance"), /*#__PURE__*/_react.default.createElement("td", {
    rowSpan: "4",
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("b", null, "Yes")), /*#__PURE__*/_react.default.createElement("td", {
    rowSpan: "4",
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("b", null, "Yes*"))), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, "Social Security Award Letter")), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, "Disability Award Letter")), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, "Divorce Decree, Child Support Order & DES received payment history")), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
    colSpan: "3",
    style: {
      background: '#ececec'
    }
  }, /*#__PURE__*/_react.default.createElement("b", null, "Asset Documents"))), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, "Checking / Saving Bank Account Statements: Bank statements for recent two consecutive months"), /*#__PURE__*/_react.default.createElement("td", {
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("b", null, "Yes")), /*#__PURE__*/_react.default.createElement("td", {
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("b", null, "Yes*"))), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, "Gift Funds: ", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "Completely filled Gift letter signed by the donor."), /*#__PURE__*/_react.default.createElement("li", null, "Donor's bank statement"))), /*#__PURE__*/_react.default.createElement("td", {
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("b", null, "Yes")), /*#__PURE__*/_react.default.createElement("td", {
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("b", null, "No"))), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, "Retirement Accounts / Stocks and Bonds", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "Recent statement covering minimum of 60 days"), /*#__PURE__*/_react.default.createElement("li", null, "Terms and Conditions of Withdrawal confirming sufficient access to withdraw funds whenever required"))), /*#__PURE__*/_react.default.createElement("td", {
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("b", null, "Yes")), /*#__PURE__*/_react.default.createElement("td", {
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("b", null, "Yes*"))), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
    colSpan: "3",
    style: {
      background: '#ececec'
    }
  }, /*#__PURE__*/_react.default.createElement("b", null, "Transaction Specific Documents"))), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
    colSpan: "3"
  }, /*#__PURE__*/_react.default.createElement("b", null, /*#__PURE__*/_react.default.createElement("em", null, "Purchase")))), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, "Purchase / Sales Contract or Offer to Purchase with all Addenda (Attachments and Enclosures) "), /*#__PURE__*/_react.default.createElement("td", {
    rowSpan: "2",
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("b", null, "Yes")), /*#__PURE__*/_react.default.createElement("td", {
    rowSpan: "2",
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("b", null, "No"))), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, "Copy of the Earnest Money Check and Receipt from the Title / Escrow company")), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, "Mortgage statements for mortgages associated with other properties owned"), /*#__PURE__*/_react.default.createElement("td", {
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("b", null, "Yes")), /*#__PURE__*/_react.default.createElement("td", {
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("b", null, "Yes*"))), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
    colSpan: "3"
  }, /*#__PURE__*/_react.default.createElement("b", null, /*#__PURE__*/_react.default.createElement("em", null, "Refinance")))), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, "Mortgage statements for mortgages associated with other properties owned"), /*#__PURE__*/_react.default.createElement("td", {
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("b", null, "Yes")), /*#__PURE__*/_react.default.createElement("td", {
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("b", null, "Yes*"))), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, "Current Mortgage Statement(s)"), /*#__PURE__*/_react.default.createElement("td", {
    rowSpan: "4",
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("b", null, "No")), /*#__PURE__*/_react.default.createElement("td", {
    rowSpan: "4",
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("b", null, "Yes*"))), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, "Homeowner's Insurance Declaration page reflecting annual premium")), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, "Tax Bill / Tax Certificate")), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, "Current Homeowners' Association (HOA) bill"))))), /*#__PURE__*/_react.default.createElement("small", null, "*Not required, in case of a streamline refinance program."))));
};
var _default = exports.default = DocsNeeded;